module.exports = __webpack_public_path__ + "static/media/publicServices.95c479a1.svg";